import { Attendance, Store } from "data-handler/ducks/stores";
import {
  deliveryCategory,
  studentAttendanceCategory,
  takeHomeRationCategory,
} from "SCConstants";

export const getModelValue = (model: string, type: string) => {
  let value = 0;
  let isDelete = type === "delete";

  switch (model) {
    case "year":
      value = isDelete ? 1 : 16;
      break;
    case "enrolment":
      value = isDelete ? 2 : 15;
      break;
    case "purchasedetail":
      value = isDelete ? 3 : 14;
      break;
    case "delivery":
      value = isDelete ? 4 : 13;
      break;
    case "incident":
      value = isDelete ? 5 : 12;
      break;
    case "attendance":
      value = isDelete ? 6 : 11;
      break;
    case "offlineuser":
      value = isDelete ? 7 : 10;
      break;
    default:
      value = isDelete ? 8 : 9;
      break;
  }
  return value;
};

export const sortModels = (stores: Store[] = []) => {
  return (stores || []).sort(
    (a, b) => getModelValue(b.model, b.type) - getModelValue(a.model, a.type)
  );
};

export const isMealAttendance = (store: Store): store is Attendance =>
  store.model === "attendance" && store.category === deliveryCategory;

export const isStudentAttendance = (store: Store): store is Attendance =>
  store.model === "attendance" && store.category === studentAttendanceCategory;

export const isTakeHomeRationAttendance = (store: Store): store is Attendance =>
  store.model === "attendance" && store.category === takeHomeRationCategory;
